import React from "react";
import { NavLink } from "react-router-dom";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import InstagramIcon from "@material-ui/icons/Instagram";
import FooterLogo from "../../images/byteskull-footer.svg";
import HomeIcon from "@mui/icons-material/Home";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

const Footer = () => {
  var CurrentYear = new Date().getFullYear();

  return (
    <>
      {/* Footer */}
      <footer className="text-center text-lg-start bg-light text-muted">
        {/* Section: Social media */}
        <section className="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">
          {/* Left */}
          <div className="me-5 ml-4 d-none d-lg-block">
            <span>Get connected with us on social networks:</span>
          </div>
          {/* Left */}
          {/* Right */}
          <div className="mr-4">
            <span className="mx-2">
              <a
                className="me-4 text-reset"
                href="https://twitter.com/byteskull"
                target="_blank"
              >
                <TwitterIcon fontSize="small" />
              </a>
            </span>
            <span className="mx-2">
              <a
                className="me-4 text-reset"
                href="https://linkedin.com/company/byteskull-technologies"
                target="_blank"
              >
                <LinkedInIcon fontSize="small" />
              </a>
            </span>
            <span className="mx-2">
              <a
                className="me-4 text-reset"
                href="https://instagram.com/byteskull"
                target="_blank"
              >
                <InstagramIcon fontSize="small" />
              </a>
            </span>
          </div>
          {/* Right */}
        </section>
        {/* Section: Social media */}
        {/* Section: Links  */}
        <section className="">
          <div className="container text-center text-md-start mt-5">
            {/* Grid row */}
            <div className="row mt-3">
              {/* Grid column */}
              <div className="col-md-3 col-lg-4 col-xl-3 mx-auto mb-4">
                {/* Content */}
                <div className="container mb-0">
                  <img
                    className="figure-img img-fluid "
                    width="250"
                    src={FooterLogo}
                  />
                </div>
                <p>
                  Empowering Possibilities, One Byte of Innovation at a Time.
                </p>
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div className="col-md-2 col-lg-2 col-xl-4 mx-auto mb-4">
                {/* Links */}
                <h6 className="text-uppercase fw-bold mb-4">Services</h6>
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/0`}
                >
                  <p>Web Development</p>
                </NavLink>
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/2`}
                >
                  <p>Software Development</p>
                </NavLink>
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/3`}
                >
                  <p>Cloud Services</p>
                </NavLink>
                <NavLink
                  className="text-reset text-decoration-none"
                  to={`/service/4`}
                >
                  <p>Graphic Designing</p>
                </NavLink>
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
                {/* Links */}
                <h6 className="text-uppercase fw-bold mb-4">Useful links</h6>
                <NavLink
                  className="text-reset text-decoration-none"
                  to="/about"
                >
                  <p>About</p>
                </NavLink>
                <NavLink
                  className="text-reset text-decoration-none"
                  to="/career"
                >
                  <p>Career</p>
                </NavLink>
                <NavLink className="text-reset text-decoration-none" to="/faq">
                  <p>FAQs</p>
                </NavLink>
                <NavLink
                  className="text-reset text-decoration-none"
                  to="/privacy-policy"
                >
                  <p>Privacy Policy</p>
                </NavLink>
              </div>
              {/* Grid column */}
              {/* Grid column */}
              <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                {/* Links */}
                <h6 className="text-uppercase fw-bold mb-4">Contact</h6>
                <p>
                  <HomeIcon fontSize="small" /> New Delhi, INDIA
                </p>
                <p>
                  <EmailIcon fontSize="small" /> team.byteskull@gmail.com
                </p>
                <p>
                  <PhoneIcon fontSize="small" />{" "}
                  <span>
                    +91 96509 37143 <br /> +91 78400 91293
                  </span>
                </p>
              </div>
              {/* Grid column */}
            </div>
            {/* Grid row */}
          </div>
        </section>
        {/* Section: Links  */}
        {/* Copyright */}
        <div
          className="text-center p-4"
          style={{ backgroundColor: "rgba(0, 0, 0, 0.05)" }}
        >
          &copy; {CurrentYear} Byteskull Technologies - All rights reserved.
        </div>
        {/* Copyright */}
      </footer>
      {/* Footer */}
    </>
  );
};

export default Footer;
